<template>
    <div style="display: flex; justify-content: center;">
        <div style="text-align: left; line-height: 2; margin-bottom: 12px;">
            <div style="display: flex; align-items: center; x-border-bottom: 1px solid #aaa;">
                <mdi :size="18" style="-webkit-filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 1)); filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 1));color: white; margin-bottom: 2px;">mdiCheck</mdi>
                <div style="font-size: 13px; flex-grow: 1; font-weight: 600; line-height: 1.3; padding-left: 10px; padding-bottom: 6px; padding-top: 6px;">
                    Revolutionary SMART plan
                </div>
                <!-- <div v-if="price > 0" style="font-size: 14px; margin-left: 16px; font-weight: 600; white-space: nowrap;" >{{ partialPrice * 5 | asPrice }}&nbsp;<small>{{ currency }}</small></div> -->
            </div>

            <div v-if="showPhotos" style="display: flex; align-items: center; x-border-bottom: 1px solid #aaa; ">
                <mdi :size="18" style="-webkit-filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 1)); filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 1));color: white; margin-bottom: 2px;">mdiCheck</mdi>
                <div style="font-size: 13px; flex-grow: 1; font-weight: 600; line-height: 1.3; padding-left: 10px; padding-bottom: 6px; padding-top: 6px;">
                    1000+ dental PHOTOS
                </div>
                <!-- <div v-if="price > 0" style="font-size: 14px; margin-left: 10px; font-weight: 600; white-space: nowrap;" >{{ partialPrice * 2 | asPrice }}&nbsp;<small>{{ currency }}</small></div> -->
            </div>

            <div style="display: flex; align-items: center; x-border-bottom: 1px solid #aaa; ">
                <mdi :size="18" style="-webkit-filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 1)); filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 1));color: white; margin-bottom: 2px;">mdiCheck</mdi>
                <div style="font-size: 13px; flex-grow: 1; font-weight: 600; line-height: 1.3; padding-left: 10px; padding-bottom: 6px; padding-top: 6px;">
                    100+ unique VIDEOS
                </div>
                <!-- <div v-if="price > 0" style="font-size: 14px; margin-left: 10px; font-weight: 600; white-space: nowrap;" >{{ partialPrice * 2 | asPrice }}&nbsp;<small>{{ currency }}</small></div> -->
            </div>

            <div style="display: flex; align-items: center; x-border-bottom: 1px solid #aaa; ">
                <mdi :size="18" style="-webkit-filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 1)); filter: drop-shadow( 1px 1px 1px rgba(0, 0, 0, 1));color: white; margin-bottom: 2px;">mdiCheck</mdi>
                <div style="font-size: 13px; flex-grow: 1; font-weight: 600; line-height: 1.3; padding-left: 10px; padding-bottom: 6px; padding-top: 6px;">
                    Save, export & send
                </div>
                <!-- <div v-if="price > 0" style="font-size: 14px; margin-left: 10px; font-weight: 600; white-space: nowrap;" >{{ partialPrice * 1 | asPrice }}&nbsp;<small>{{ currency }}</small></div> -->
            </div>

            <!-- <div style="display: flex; align-items: center; border-bottom: 0px solid #ddd; ">
                <mdi style="opacity: 0; color: green; margin-bottom: 6px;">mdiCheck</mdi>
                <div style="flex-grow: 1; font-weight: 900; line-height: 1.3; padding-left: 10px; padding-bottom: 6px; padding-top: 6px;">
                    TOTAL<br/>
                </div>
                <div v-if="price > 0" style="text-decoration: line-through; font-size: 18px; margin-left: 10px; font-weight: 600; white-space: nowrap;" >{{ partialPrice * 10 | asPrice }}&nbsp;<small>{{ currency }} / month</small></div>
            </div> -->

            <!-- <div style="display: flex; align-items: center;">
                <mdi style="color: green; margin-bottom: 6px;">mdiCheck</mdi>
                <div style="flex-grow: 1; font-weight: 600; line-height: 1.3; padding-left: 12px; border-bottom: 0px solid #ddd; padding-bottom: 6px; margin-bottom: 6px;">
                    150.000+ downloads<br/>
                    <span style="font-size:13px">Used by many dentists worldwide</span>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            currency: {
                type: String,
                default: ""
            },
            price: {
                type: Number,
                default: 0,
            }
        },
        computed: {
            showPhotos() {
                return true;
                return window.localStorage.getItem('userEmail') === null;
            },
            partialPrice() {
                if (this.price === 0) return 0;
                return this.price / 10;
            }
        },
        filters: {
            asPrice(val) {
                const hasDecimals = parseInt(val) !== parseFloat(val);
                return (hasDecimals ? val.toFixed(2) : val);
            }
        }
    }
</script>
